import { cardsDateService } from "./services";
import { LibCard, ItemPage } from "./components";
import { faBank } from "@fortawesome/free-solid-svg-icons";
import { IModuleConfig } from "../../interfaces";
import { ModuleTypeEnum } from "../../enums";
import {
  AddButton,
  CancelButton,
  DeleteButton,
  EditButton,
  SaveButton,
  ExportButton
} from "./components/toolbar-items";
import {UserPermissions} from "../../definitions"

const config: IModuleConfig = {
  id: "cards",
  name: "Cards",
  view_permission: UserPermissions.viewCards,
  edit_permission: UserPermissions.editCards,
  icon: faBank,
  moduleType: ModuleTypeEnum.DualPaneLibrary,
  allowSearch: true,
  components: {
    libraryCard: LibCard,
    itemPage: ItemPage
  },
  services: {
    getByPage: cardsDateService.getByPage,
    getSingle: cardsDateService.getSingle,
    create: cardsDateService.create,
    update: cardsDateService.update
  },
  utilities: {
    extractKey: (d: any) => {
      return d._id;
    },
    extractItemPath: (d: any) => d._id,
    extractItemBreadcrumb: (d: any) => {
      return d.main_program;
    }
  },
  toolbarItems: {
    library: [AddButton, ExportButton],
    create: [CancelButton, SaveButton],
    edit: [CancelButton, SaveButton],
    view: [AddButton, EditButton, DeleteButton]
  }
};

export default config;
